module.exports = __webpack_public_path__ + "static/media/Boton_HPLVIDA.469ac92f.webp";